<template>
  <v-main>

    <v-container class="fill-height" fluid>
    <ForgotPassword />
    </v-container>
  </v-main>
</template>

<script>
import ForgotPassword from "./ForgotPassword.vue";
export default {
  name: "index.vue",
  components: {
    ForgotPassword,
  },
  data() {
    return {};
  },
}
</script>

<style scoped>

</style>